import { cva } from 'class-variance-authority';

export const progressVariants = cva('relative h-1 w-full overflow-hidden rounded-full', {
  variants: {
    variant: {
      default: 'bg-white/20',
      rainbow: 'h-2 bg-white/20',
    },
  },
  defaultVariants: {
    variant: 'default',
  },
});

export const progressIndicatorVariants = cva('h-full w-full flex-1 transition-all', {
  variants: {
    variant: {
      default: 'bg-white',
      rainbow: 'bg-rainbow-gradient',
    },
  },
  defaultVariants: {
    variant: 'default',
  },
});
